import { Spinner } from '@/view/components/ui/spinner'
import { useConfigsPage } from './useConfigsPage'
import { ConfigCardWithModal } from './components/ConfigCardWithModal'
import { FeaturesCardWithModal } from './components/FeaturesCardWithModal'
import { useAuth } from '@/app/hooks/useAuth'

const MERGED_TYPES = ['features', 'actions', 'pages']

export const ConfigsPage = () => {
  const { configs, refetch } = useConfigsPage()
  const { isSuperAdmin } = useAuth()

  if (!configs) {
    return (
      <div className="flex justify-center py-8">
        <Spinner />
      </div>
    )
  }

  const mergedConfigs = configs.filter((c) => MERGED_TYPES.includes(c.type))
  const otherConfigs = configs.filter((c) => !MERGED_TYPES.includes(c.type))

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '8px',
      }}
    >
      {isSuperAdmin && (
        <>
          {otherConfigs.map((config, index) => (
            <ConfigCardWithModal
              key={index}
              config={config}
              onSubmit={refetch}
            />
          ))}
          {mergedConfigs.length > 0 && (
            <FeaturesCardWithModal configs={mergedConfigs} onSubmit={refetch} />
          )}
        </>
      )}
    </div>
  )
}
